/**
 * @file track-list.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _eventTarget = require('../event-target');

var _eventTarget2 = _interopRequireDefault(_eventTarget);

var _utilsFnJs = require('../utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _utilsBrowserJs = require('../utils/browser.js');

var browser = _interopRequireWildcard(_utilsBrowserJs);

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

/**
 * Common functionaliy between Text, Audio, and Video TrackLists
 * Interfaces defined in the following spec:
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html
 *
 * @param {Track[]} tracks A list of tracks to initialize the list with
 * @param {Object} list the child object with inheritance done manually for ie8
 * @extends EventTarget
 * @class TrackList
 */

var TrackList = (function (_EventTarget) {
  _inherits(TrackList, _EventTarget);

  function TrackList() {
    var tracks = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
    var list = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

    _classCallCheck(this, TrackList);

    _EventTarget.call(this);
    if (!list) {
      list = this;
      if (browser.IS_IE8) {
        list = _globalDocument2['default'].createElement('custom');
        for (var prop in TrackList.prototype) {
          if (prop !== 'constructor') {
            list[prop] = TrackList.prototype[prop];
          }
        }
      }
    }

    list.tracks_ = [];
    Object.defineProperty(list, 'length', {
      get: function get() {
        return this.tracks_.length;
      }
    });

    for (var i = 0; i < tracks.length; i++) {
      list.addTrack_(tracks[i]);
    }

    return list;
  }

  /**
   * change - One or more tracks in the track list have been enabled or disabled.
   * addtrack - A track has been added to the track list.
   * removetrack - A track has been removed from the track list.
   */

  /**
   * Add a Track from TrackList
   *
   * @param {Mixed} track
   * @method addTrack_
   * @private
   */

  TrackList.prototype.addTrack_ = function addTrack_(track) {
    var index = this.tracks_.length;

    if (!('' + index in this)) {
      Object.defineProperty(this, index, {
        get: function get() {
          return this.tracks_[index];
        }
      });
    }

    // Do not add duplicate tracks
    if (this.tracks_.indexOf(track) === -1) {
      this.tracks_.push(track);
      this.trigger({
        track: track,
        type: 'addtrack'
      });
    }
  };

  /**
   * Remove a Track from TrackList
   *
   * @param {Track} rtrack track to be removed
   * @method removeTrack_
   * @private
   */

  TrackList.prototype.removeTrack_ = function removeTrack_(rtrack) {
    var track = undefined;

    for (var i = 0, l = this.length; i < l; i++) {
      if (this[i] === rtrack) {
        track = this[i];
        if (track.off) {
          track.off();
        }

        this.tracks_.splice(i, 1);

        break;
      }
    }

    if (!track) {
      return;
    }

    this.trigger({
      track: track,
      type: 'removetrack'
    });
  };

  /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {String} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */

  TrackList.prototype.getTrackById = function getTrackById(id) {
    var result = null;

    for (var i = 0, l = this.length; i < l; i++) {
      var track = this[i];
      if (track.id === id) {
        result = track;
        break;
      }
    }

    return result;
  };

  return TrackList;
})(_eventTarget2['default']);

TrackList.prototype.allowedEvents_ = {
  change: 'change',
  addtrack: 'addtrack',
  removetrack: 'removetrack'
};

// emulate attribute EventHandler support to allow for feature detection
for (var _event in TrackList.prototype.allowedEvents_) {
  TrackList.prototype['on' + _event] = null;
}

exports['default'] = TrackList;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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